<template>
	<div style="padding: 10px 10px 10px 0;">
		<el-dialog  width="50%">
		<el-form :model="formline" label-width="150px" :inline="true">
			<el-form-item label="发票抬头">
				<el-input placeholder="请输入" v-model="formline.invoiceHand"></el-input>
			</el-form-item>
			<el-form-item label="收件人">
				<el-input placeholder="请输入" v-model="formline.receiveName"></el-input>
			</el-form-item>
			<el-form-item label="手机号">
				<el-input placeholder="请输入" v-model="formline.receivePhone"></el-input>
			</el-form-item>
			<el-form-item label="发票类型">
				<el-select  v-model="formline.invoiceType">
					<el-option label="企业" value="1"></el-option>
					<el-option label="个人" value="2"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="开票状态" prop="roomNum">
				<el-select v-model="formline.invoiceStatus">
					<el-option label="已开票" :value="1"></el-option>
					<el-option label="未开票" :value="2"></el-option>
					<el-option label="审核中" :value="3"></el-option>
				</el-select>
				<!-- 	<el-input v-model="selectForm.roomNum" placeholder="商铺号"></el-input> -->
			</el-form-item>
			<el-form-item>
				<el-button type="primary" @click="getAll()">查询</el-button>
			</el-form-item>
			<!-- <el-form-item>
				<el-button type="primary" @click="dc()">导出</el-button>
			</el-form-item> -->
		</el-form>
		</el-dialog>
		<el-table :data="formDate" style="width: 100%" border>
			<el-table-column prop="id" label="发票编号" ></el-table-column>
		<!-- 	<el-table-column prop="username" label="流水号"></el-table-column> -->
			<el-table-column prop="receiveName" label="收件人"></el-table-column>
			<el-table-column prop="invoiceContent" label="发票内容"></el-table-column>
			<el-table-column prop="receivePhone" label="手机号"></el-table-column>
			<el-table-column prop="invoiceHand" label="发票抬头"></el-table-column>
			<el-table-column prop="invoiceType" label="发票类型">
				<template slot-scope="{row}">
					{{row.invoiceType==1?'企业':'个人'}}
				</template>
			</el-table-column>
			<el-table-column prop="invoiceStatus" label="开票状态">
				<template slot-scope="{row}">
					{{row.invoiceStatus==1?'已开票':row.invoiceStatus==2?'未开票':'审核中'}}
				</template>
			</el-table-column>
			<el-table-column prop="createTime" label="申请时间">
				<template slot-scope="{row}">{{setTime(row.createTime)}}</template>
			</el-table-column>
			<el-table-column label="操作" align="center">
				<template slot-scope="scope">
					<!-- 	<el-button type="text" @click="setRow(scope.row)">查看</el-button> -->
					<el-button type="text" @click="xgRow(scope.row)">查看</el-button>
				</template>
			</el-table-column>
		</el-table>
		<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
			:page-sizes="[10, 20, 30, 50]" :page-size="formline.page" layout="total, sizes, prev, pager, next, jumper"
			:total="totalNum">
		</el-pagination>
		<el-dialog title="修改" :visible.sync="isShow" width="30%">
			<el-form :model="list" class="demo-form-inline">
				
				
					<el-form-item label="发票编号">
						<el-input v-model="list.id" :disabled="true"></el-input>
					</el-form-item>
					<el-form-item label="税号">
						<el-input v-model="list.dutyParagraph" :disabled="true"></el-input>
					</el-form-item>
					<el-form-item label="邮箱">
						<el-input v-model="list.receiveEmail" :disabled="true"></el-input>
					</el-form-item>
					<el-form-item label="收件人">
						<el-input v-model="list.receiveName" :disabled="true"></el-input>
					</el-form-item>
			
					<el-form-item label="发票内容">
						<el-input v-model="list.invoiceContent" :disabled="true"></el-input>
					</el-form-item>
					<el-form-item label="手机号">
						<el-input v-model="list.receivePhone" :disabled="true"></el-input>
					</el-form-item>
				
					<el-form-item label="发票抬头">
						<el-input v-model="list.invoiceHand" :disabled="true"></el-input>
					</el-form-item>
					<el-form-item label="发票类型">
						<el-input v-model="list.invoiceType==1?'企业':'个人'" :disabled="true"></el-input>
					</el-form-item>
					<el-form-item label="申请时间">
						<el-input v-model="list.createTime" :disabled="true"></el-input>
					</el-form-item>
				<el-form-item label="开票状态" prop="roomNum">
					<el-select v-model="list.invoiceStatus">
						<el-option label="已开票" :value="1"></el-option>
						<el-option label="未开票" :value="2"></el-option>
						<el-option label="审核中" :value="3"></el-option>
					</el-select>
					<!-- 	<el-input v-model="selectForm.roomNum" placeholder="商铺号"></el-input> -->
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="isShow = false">取 消</el-button>
				<el-button type="primary" @click="sfQd">确定</el-button>
			</span>
		</el-dialog>
	</div>
</template>
<script>
	import publicExport from '../../assets/js/publicExport.js';
	export default {
		data() {
			return {
				formline: {
					invoiceHand:null,
					receiveName: null,
					receivePhone: null,
					invoiceType:null,
					invoiceStatus:null,
					page:1,
					rows:10
				},
				type: "巡检上报",
				xjList:[],
				formDate:[],
				totalNum:null,
				isShow:false,
				list:{}
			};
		},
		mounted() {
			this.getAll()
			this.getXj()
		},
		methods: {
			sfQd(){
				this.$http.post("/api/invoiceManagement/updateInvoiceManagement",{
					...this.list
				}).then(res=>{
					this.isShow=false
					this.$message(res.data.message)
					this.getAll()
					console.log(res)
				})
			},
			xgRow(val){
				console.log(val)
				this.list={...val}
				this.list.createTime=this.setTime(this.list.createTime)
				this.isShow=true
			},
			dc() {
				publicExport("/api/bdPolling/exportPolling", this.formline, this.type)
			},
			getXj(){
				this.$http.get("/api/bdCheckWorkAttendance/selectSecurityUser").then(res=>{
					console.log(res)
					this.xjList=res.data.data
				})
			},
			getAll(){
				this.$http.post("/api/invoiceManagement/selectInvoiceManagement",{
					...this.formline
				}).then(res=>{
					console.log(res)
					if(res.data.code==0){
						this.formDate=res.data.data.items
						this.totalNum=res.data.data.totalNum
					}else{
						this.formDate=res.data.data
						this.totalNum=0
						this.$message.error(res.data.message)
					}
					
				})
			},
			handleCurrentChange(val) {
				this.formline.page = val
				this.getAll()
			},
			handleSizeChange(val) {
				this.formline.rows = val
				this.getAll()
			},
		}
	};
</script>
<style scoped="scoped">
</style>
